import driver from './driver'
import document from './document'
import license from './license'

export default {
  driver,
  document,
  license
}
